import { render, staticRenderFns } from "./bankArchiveList.vue?vue&type=template&id=b858120a&scoped=true"
import script from "./bankArchiveList.vue?vue&type=script&lang=js"
export * from "./bankArchiveList.vue?vue&type=script&lang=js"
import style0 from "./bankArchiveList.vue?vue&type=style&index=0&id=b858120a&prod&lang=scss&scoped=true"
import style1 from "./bankArchiveList.vue?vue&type=style&index=1&id=b858120a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b858120a",
  null
  
)

export default component.exports